import 'aws-amplify/auth/enable-oauth-listener' 

import { Amplify } from 'aws-amplify'
import { awsExport } from './utils/amplify'
Amplify.configure(awsExport)

import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import { createPinia } from 'pinia';
import { createGtm } from '@gtm-support/vue-gtm';
import i18ninstance from '@/i18n';
import { H } from 'highlight.run';
import App from './App.vue';
import router from '@/routes/index';
import './assets/index.css';
import 'element-plus/dist/index.css';
import './utils/amplify';

import 'element-plus/theme-chalk/display.css';

const app = createApp(App);

app.use(createPinia());
app.use(createHead());
app.use(i18ninstance);
app.use(router);

if (import.meta.env.MODE === 'production') {
	app.use(createGtm({
		id: 'GTM-5HZWN2NN',
		vueRouter: router,
		defer: true,
		compatibility: true,
	}));
	H.init(import.meta.env.VITE_HIGHLIGH_PROJECT_ID, {
		environment: import.meta.env.MODE,
		disableConsoleRecording: import.meta.env.MODE === 'production',
		consoleMethodsToRecord: ['log', 'error'],
		reportConsoleErrors: false,
		networkRecording: {
			enabled: true,
			recordHeadersAndBody: true,
		},
		serviceName: 'client',
		otel: {
			instrumentations: {
				"@opentelemetry/instrumentation-document-load": false,
				"@opentelemetry/instrumentation-fetch": false,
				"@opentelemetry/instrumentation-xml-http-request": false
			},
		},
	})
}

app.mount('#app');
